module.exports = __webpack_public_path__ + "static/media/Board_1@2x.87c0a924.png";